// Currency list for the Payment Links create form's Amount field. Razorpay's
// own docs (accept-international-payments-from-indian-customers,
// international-payments FAQs) don't publish one single exhaustive list for
// an India-based merchant account (this business's, per RAZORPAY_KEY_ID/
// RAZORPAY_KEY_SECRET in .env) — they instead name two overlapping sets
// across two pages. This is the union of both, INR first as the default
// (matches every other money field in this app) then the rest alphabetical
// by code. If Razorpay enables a currency for this account that isn't listed
// here, it's still reachable — razorpayClient.js's createPaymentLink()
// accepts any ISO 4217 code, this list is only what the dropdown offers.
const RAW_CURRENCIES = [
  ['INR', 'Indian Rupee'],
  ['AED', 'UAE Dirham'],
  ['AUD', 'Australian Dollar'],
  ['CAD', 'Canadian Dollar'],
  ['CHF', 'Swiss Franc'],
  ['EUR', 'Euro'],
  ['GBP', 'British Pound'],
  ['HKD', 'Hong Kong Dollar'],
  ['JPY', 'Japanese Yen'],
  ['KRW', 'South Korean Won'],
  ['KWD', 'Kuwaiti Dinar'],
  ['MYR', 'Malaysian Ringgit'],
  ['PLN', 'Polish Zloty'],
  ['SGD', 'Singapore Dollar'],
  ['USD', 'US Dollar'],
];

export const CURRENCIES = RAW_CURRENCIES.map(([code, name]) => ({ code, name }));

export const DEFAULT_CURRENCY = 'INR';
